import jQuery from 'jquery';
import cardPage from '../cardPage';
import CardSort, { SORTING_KEYS } from './CardSort';
import { PAGES } from '../../constants';

function getUserSettings() {
    const userCustomSettingsCookie = jQuery.cookie('customizeSettings');

    return userCustomSettingsCookie ? JSON.parse(userCustomSettingsCookie) : {};
}

function getPageSortingConfig(page) {
    const userSettings = getUserSettings();
    const defaultSortingMap = {
        [PAGES.FREE_CARD]: {
            defaultSorting: userSettings.orderByPrice
                ? SORTING_KEYS.PRICE
                : SORTING_KEYS.ORDER_NUMBER
        },
        [PAGES.PRO_CARD]: {
            defaultSorting: userSettings.orderByPrice
                ? SORTING_KEYS.PRICE
                : SORTING_KEYS.ORDER_NUMBER
        },
        [PAGES.STABLE_TOURS]: {
            defaultSorting: userSettings.orderByPrice
                ? SORTING_KEYS.PRICE
                : SORTING_KEYS.RACE
        },
        [PAGES.MEETING_DAY]: {
            defaultSorting: SORTING_KEYS.ORDER_NUMBER,
            initialSortingOnly: true
        },
        [PAGES.GLANCE_CARD]: {
            defaultSorting: SORTING_KEYS.ORDER_NUMBER
        }
    };

    return defaultSortingMap[page];
}

export default function () {
    const cardSort = new CardSort();
    const currentPage = cardPage.getCurrentPage();
    const currentPageSortingConfig = getPageSortingConfig(currentPage);

    if (currentPageSortingConfig.initialSortingOnly) {
        cardSort.sortRunners(currentPageSortingConfig.defaultSorting);
    } else {
        cardSort.init({ defaultSort: currentPageSortingConfig.defaultSorting });
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/cardSorting/index.js